import { render, staticRenderFns } from "./GroupTopic.vue?vue&type=template&id=fc07c18c&scoped=true"
import script from "./GroupTopic.vue?vue&type=script&lang=js"
export * from "./GroupTopic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc07c18c",
  null
  
)

export default component.exports